import BaseObjectDirective from './BaseObjectDirective';

/**
 * AsfHintObjectCtrl is a controller class that extends BaseObjectDirective.
 * It manages the behavior and state of hint objects within the application.
 */
export class AsfHintObjectCtrl extends BaseObjectDirective {
    /**
     * Constructor for AsfHintObjectCtrl.
     * @param {Object} $injector - AngularJS injector service.
     * @param {Object} $scope - AngularJS scope.
     * @param {Object} $rootScope - AngularJS root scope.
     * @param {Object} $signals - Signal service for inter-component communication.
     * @param {Object} $timeout - AngularJS timeout service.
     * @param {Object} ObjectInstanceRegistrationService - Service for registering object instances.
     * @param {Object} TaskSelectionService - Service for task selection.
     * @param {Object} FindObjectService - Service for finding objects.
     * @param {Object} TaskDataService - Service for task data management.
     */
    constructor($injector, $scope, $rootScope, $signals, $timeout, ObjectInstanceRegistrationService, TaskSelectionService, FindObjectService, TaskDataService) {
        super($injector, $scope);
        $injector.invoke(this.init, this, {$scope: $scope});

        this.registerObjectInstance('hint');
        var taskData = TaskDataService.fetchContext();

        var t = this;
        $scope.isCMS = $rootScope.isCMS && !$rootScope.isPreview;
        $scope.isLinkedToObject = false;
        $scope.hintButtonVisible = false;//$scope.contentObject.getPreferences().hintButtonVisible ? $scope.contentObject.getPreferences().hintButtonVisible : false;
        $scope.showHintExplanation = false;
        $scope.showHint = false;//$scope.contentObject.getPreferences().showHint ? $scope.contentObject.getPreferences().showHint : false;
        $scope.editMode = false;
        $scope.prefsMode = false;
        $scope.hasEditMode = false;
        $scope.hintButtonLabel = $scope.contentObject.getPreferences().hintButtonLabel ? $scope.contentObject.getPreferences().hintButtonLabel : "Need Help?" ;
        $scope.associatedMarks = $scope.contentObject.getPreferences().associatedMarks ? $scope.contentObject.getPreferences().associatedMarks : 0 ;
        $scope.linkedContentObjectUUID = $scope.contentObject.getPreferences().linkedContentObjectUUID ? $scope.contentObject.getPreferences().linkedContentObjectUUID : "no" ;

        $scope.frontendMode = $rootScope.isPreview || !$scope.isCMS ;
        var hintSiblings = [];

        //$scope.isPDFMode = true;

        //console.info("setting visibility for button ", $scope.hintButtonLabel, " hintButtonVisible", $scope.hintButtonVisible, "showhint: ", $scope.showHint);

        /**
         * Checks the visibility of the hint button based on the content object's preference level and other conditions.
         */
        $scope.checkHintVisibility = function() {
            if ($scope.contentObject.getPreference("level") === 1 && $scope.showHint === false) {
                $scope.hintButtonVisible = true;
            }
            if ($scope.showHint) {
                $scope.hintButtonVisible = false;
                angular.forEach(hintSiblings, function (item) {
                    if($scope.isPDFMode && angular.isFunction(item.setLastShowedHintObject)){
                        item.setLastShowedHintObject(false, false);
                    }
                    if (item.getPreferences().level === $scope.contentObject.getPreferences().level + 1) {
                        $signals.emit("HINT-OBJECT.HINT-BUTTON-VISIBLE", item.data.uuid);
                    }
                });
            }
        };

        if($scope.isPDFMode){
            var showedHintObjects = [];
            $scope.lastShowedHintObject = false;
            $scope.contentObject.setLastShowedHintObject = function (value, isLast) {
                $scope.lastShowedHintObject = value;
                if(isLast) return false;

                $scope.totalSumDeductedMarks = 0;
                showedHintObjects = [];

                var maxKey = 0;
                angular.forEach(hintSiblings, function (item, key) {
                    if (angular.isFunction(item.getShowHint) && item.getShowHint()) {
                        $scope.totalSumDeductedMarks += parseInt(item.getPreferences().associatedMarks);
                        showedHintObjects.push(item);
                        if(maxKey < key){
                            maxKey = key;
                        }
                    }
                });
                var lastObject = hintSiblings[maxKey];
                if (lastObject && angular.isFunction(lastObject.setLastShowedHintObject)) {
                    lastObject.setLastShowedHintObject(true, true);
                }

                $scope.allShowedHintObjectsString = showedHintObjects.map(function (elem) {
                    return String(elem.getPreferences().level);
                }).join(",");
            };

            $scope.contentObject.getShowHint = function () {
                return $scope.showHint;
            };
        }

        /**
         * Sets the response fill based on the attachment data.
         * @param {Object} attachment - The attachment containing data to set.
         */
        this.setResponseFill(function (attachment) {
             console.log("setResonseFill", $scope.hintButtonLabel);
             if(angular.isDefined(attachment.showHint)){
                 $scope.showHint = attachment.showHint;
                 console.log("set showHint", $scope.showHint);
             }
             if(angular.isDefined(attachment.hintButtonVisible)){
                 $scope.hintButtonVisible = attachment.hintButtonVisible;
                 console.log("set HintbuttonVisible", $scope.hintButtonLabel);
             }
            $scope.checkHintVisibility();
        });

        /**
         * Collects the response data into the attachment.
         * @param {Object} attachment - The attachment to collect data into.
         */
        this.setResponseCollect(function (attachment) {
            attachment.showHint = $scope.showHint;
            attachment.hintButtonVisible = $scope.hintButtonVisible;
            console.log("Collecting: ", $scope.hintButtonLabel, attachment);
        });

        if($scope.showHint){
            $scope.hintButtonVisible = false;
        }

        /**
         * Updates the registered name based on the content object's preferences.
         */
        $scope.updateRegisteredName = function() {
            var preferences = $scope.contentObject.getPreferences();
            if (!angular.isDefined(preferences.objName)) {
                return;
            }
            t.registerObjectInstanceWithName(preferences.objName);
        };

        $signals.on("HINT-OBJECT.HINT-BUTTON-VISIBLE", function (uuid) {
            if($scope.contentObject.data.uuid === uuid){
                $scope.hintButtonVisible = true;
                $scope.contentObject.setPreference("hintButtonVisible", true);
            }
        });

        /**
         * Shows the hint explanation dialog.
         */
        $scope.showHintExplanationDialog = function(){
            $scope.showHintExplanation = true;
        };

        /**
         * Hides the hint explanation dialog.
         */
        $scope.hideHintExplanationDialog = function(){
            $scope.showHintExplanation = false;
        };

        /**
         * Shows the hint confirmation dialog.
         */
        $scope.showHintConfirmationDialog = function(){
            $scope.showHintExplanation = false;
            $scope.showHintConfirmation = true;
        };

        /**
         * Hides the hint confirmation dialog.
         */
        $scope.hideHintConfirmationDialog = function(){
            $scope.showHintConfirmation = false;
        };

        /**
         * Confirms the hint, updating relevant scope variables and preferences.
         */
        $scope.confirmHint = function () {
            $scope.showHintExplanation = false;
            $scope.hintButtonVisible = false;
            $scope.showHintConfirmation = false;
            $scope.showHint = true;
            $scope.contentObject.setPreference("showHint", true);
            $scope.contentObject.setPreference("hintButtonVisible", false);

            $scope.checkHintVisibility();
        };
        $scope.selected = "";
        $scope.taskuuid  = TaskSelectionService.getTaskUUID();

        //if(  $scope.contentObject.getPreference("level") > 1){
        //    $scope.contentObject.setPreference("hintButtonVisible", false);
        //}

        var taskDataNew = TaskDataService.fetchContext();
        var parents = taskDataNew.getParentsEntryByUUID($scope.contentObject.getUUID());
        var scopeParent = _.find(parents, function (item) {
            return item.getType() === 'container';
        });

        angular.forEach(scopeParent.data.objects, function(value) {
            var obj = taskDataNew.read(value);
            var objectType = obj.data.objectType;
            if (objectType === "hint"){
                hintSiblings.push(obj);
            }
        });

        /**
         * Searches for a container object within the parent hierarchy.
         * @param {Object} parent - The parent object to start the search from.
         * @returns {Object|undefined} - The found container object or undefined.
         */
        var searchContainerObject = function(parent){
            var containerObj = "";

            if(angular.isDefined(parent.objectType) && parent.objectType === "container"){
                return parent;
            } else if (parent === null) {
                searchContainerObject(parent.$parent);
            } else {
            }

        };

        var selectableLevels = [{"label": "1", "option": 1}, {"label": "2", "option": 2}, {"label": "3", "option": 3}];

        if ($scope.frontendMode) {
            $scope.checkHintVisibility();
            return;
        }

        /**
         * Initializes the preferences for the content object.
         */
        $scope.initPreferences = function() {
            var definedLevels = [1,2,3];
            var selectableLevels = ["1 - shown directly", "2 - after level 1", "3 - after level 2"];

            if (!$scope.frontendMode && typeof $scope.contentObject.getPreferences() !== "undefined") {
                $scope.contentObject.getPreferences().showHint = false;
            }

            var objName =       (typeof $scope.contentObject.getPreferences() != "undefined" ? $scope.contentObject.getPreferences().objName : undefined);
            var includedInPDF = (typeof $scope.contentObject.getPreferences() !== "undefined" ? $scope.contentObject.getPreferences().includedInPDF : true);
            var hintButtonLabel = (typeof $scope.contentObject.getPreferences() !== "undefined" ? $scope.contentObject.getPreferences().hintButtonLabel : true);
            var associatedMarks = (typeof $scope.contentObject.getPreferences() !== "undefined" ? $scope.contentObject.getPreferences().associatedMarks : true);
            //var selectableLevels = (typeof $scope.contentObject.getPreferences() !== "undefined" ? $scope.contentObject.getPreferences().selectableLevels : true);
            var level = (typeof $scope.contentObject.getPreferences() !== "undefined" ? $scope.contentObject.getPreferences().level : true);

            var TaskInfoService = $injector.get('TaskInfoService'),
                taskInfo        = TaskInfoService.getTaskInfo();

            $scope.$watch('preferencesValues', function(val1, val2) {
                if (val1 == val2) {
                    return;
                }
                var preferences = {};
                angular.forEach($scope.preferencesValues, function(value, key) {
                    preferences[key] = value
                });
                $scope.updateRegisteredName();
                $scope.contentObject.setPreferences(preferences);

                if (isCMS) {
                    var parent_containers = _.find($scope.contentObject.getParents(), function (item) {
                        return item.getType() === 'container';
                    });

                    var parent_container;
                    for (var key in parent_containers) {
                        var container = parent_containers[key];
                        if (container && angular.isFunction(container.getObjects)) {
                            if (container.getObjects() && container.getObjects().length && container.getObjects().indexOf($scope.contentObject.getUUID()) !== -1) {
                                parent_container = container;
                            }
                        }
                    }

                    if (parent_container && angular.isFunction(parent_container.getObjects) && parent_container.getObjects().length > 0) {
                        var objects = parent_container.getObjects();

                        for (var key in objects) {
                            var uuid = objects[key];
                            if (!angular.isUUID(uuid)) continue;
                            var content_object = taskDataNew.read(uuid);
                            if (content_object.getObjectType() !== 'hint') continue;
                            if ($scope.contentObject.getUUID() !== content_object.getUUID()) {
                                content_object.validate($scope.contentObject);
                            }
                        }
                    }
                }
            }, true);

            $scope.preferencesValues = {};
            $scope.preferencesValues["objName"] = objName;
            $scope.preferencesValues["hintButtonLabel"] =  hintButtonLabel;
            $scope.preferencesValues["includedInPDF"] = typeof includedInPDF !== 'undefined' ? includedInPDF : false;
            $scope.preferencesValues["associatedMarks"] = associatedMarks;
            $scope.preferencesValues["selectableLevels"] = selectableLevels;
            $scope.preferencesValues["level"] = level;

            $scope.preferences = [
                {
                    'includedInPDF': [
                        {'type': 'checkbox', 'name': 'Included in Response PDF', 'valueKey': 'includedInPDF'}
                    ],
                    '02-other': [
                        {'type': 'input', 'name': 'Object Name', 'valueKey': 'objName'},
                        {'type': 'input', 'name': 'Button Label', 'valueKey': 'hintButtonLabel'},
                        {'type': 'input', 'name': 'Marks not achievable', 'valueKey': 'associatedMarks'}
                    ],
                    'level':[
                        {'type':'select', 'name': 'Select Hint Level', 'options': definedLevels, 'valueKey': 'level'}
                    ]
                },
            ];

        };
        // execute helpers
        $scope.initPreferences();
        $scope.updateRegisteredName();

    }
}

/**
 * Registers the AsfHintObject directive within the specified module.
 * @param {Object} module - The AngularJS module to register the directive in.
 */
export default function registerAsfHintObjectDirective(module) {
    module.directive('asfHintObject', function($compile, $bridges, $config, TaskDataService, $rootScope, $timeout, ObjectInstanceRegistrationService) {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                "contentObject": "="
            },
            templateUrl: "/views/ib/contentobjects/hint.html",
            controller: AsfHintObjectCtrl
        };
    });

    module.run(['ContentObjectRegistryService', function(ContentObjectRegistryService) {
        var obj = [{
            "uuid": "",
            "content": "",
            "objectType": "hint",
            "type": "contentObject",
            "entity_content": "",
            "preferences": {
                "height": "300",
                "spellchecker_language": null,
                "autogrow": true,
                "includedInPDF" : true,
                "hintButtonLabel" : "Need Help?",
                "hintButtonVisible": false,
                "showHint": false,
                "associatedMarks" : 0,
                "hintVisible": false,
                "level": 0
            }
        }];
        var objProperties = {
            type: "hint",
            isResponse: true,
            label: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.HINT-OBJECT.LABEL',
            cssClass: "new-hint-object",
            icon: "cms/icon-standard.png",
            description: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.HINT-OBJECT.DESCRIPTION',
            group: {
                id: 1
            }
        };
        ContentObjectRegistryService.register(obj, objProperties);
    }]);
}